module.exports = __webpack_public_path__ + "img/logo-cantine.2b18fcaa.png";